// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2mE2d","notes":"Notes_notes__34a6k"};